import { DateTime } from 'luxon';
import { StateRegistrationCitizenship } from 'mutation/constants/state-registration-citizenship';
import { ModelEventoDTO } from 'shell/models/act-category-list';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

export const transformerEditDataControl = (
  modelEventoDTO?: ModelEventoDTO,
  subEvento?: string
): AccordionEditDataControl | undefined => {
  switch (subEvento) {
    case StateRegistrationCitizenship.OpenLegis:
      return {
        dateValidity: modelEventoDTO?.trascrizioneCittadinanza?.dataAccertamento
          ? DateTime.fromISO(modelEventoDTO?.trascrizioneCittadinanza?.dataAccertamento)
          : null,
      };
    case StateRegistrationCitizenship.ToDPR:
    case StateRegistrationCitizenship.ItalianCitizenshipDP:
      return {
        dateValidity: modelEventoDTO?.dataformazione
          ? DateTime.fromISO(modelEventoDTO?.dataformazione).plus({ day: 1 })
          : null,
      };
    default:
      return;
  }
};
